import React from 'react';
import { styled } from '@stitches/react';
import { motion } from 'framer-motion';
import HeroSection from './sections/HeroSection';
import HowToMineSection from './sections/HowToMineSection';
import MiningPoolsSection from './sections/MiningPoolsSection';
import FeaturesSection from './sections/FeaturesSection';
import AchievementsSection from './sections/AchievementsSection';
import PartnersSection from './sections/PartnersSection';
import RewardSystemSection from './sections/FeedbackSection';
// 页面容器样式
const PageContainer = styled(motion.div, {
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'var(--background-color)', // 深色背景作为全局底色
  overflow: 'hidden'
});

// 首页动画变体
const pageVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: 'easeIn'
    }
  }
};

// 未使用的样式组件已删除

/**
 * 首页组件
 * 包含多个展示区块，展示平台核心功能和优势
 * 添加了页面进入动画和各区块滚动显示动画
 * 已实现完整的国际化支持 - 各个子组件都使用了各自的useTranslation钩子
 */
const HomePage: React.FC = () => {
  return (
    <PageContainer
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
    >
      {/* 英雄区块 - 引导用户注册和了解服务 */}
      <HeroSection />
      
      {/* 如何成为矿工 - 展示注册流程 - 白色背景区域 */}
      <HowToMineSection />
      
      {/* 矿区选择 - 展示不同挖矿解决方案 - 白色背景区域 */}
      <MiningPoolsSection />
      
      {/* 平台特性 - 展示平台优势 - 白色背景区域 */}
      <FeaturesSection />
      
      {/* 平台成就 - 展示平台数据 - 白色背景区域 */}
      <AchievementsSection />
      
      {/* BITENGINEINE 生态奖励计划 - 展示奖励机制 */}
      <RewardSystemSection />      

      {/* 合作伙伴 - 展示合作伙伴 - 白色背景区域 */}
      <PartnersSection />
    </PageContainer>
  );
};

export default HomePage; 